import React from "react";

const Bbpshistory = () => {
  return (
    <>
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <div className="row">
            <div className="col-sm-4">
              <h4>
                <b>BBPS Report</b>
              </h4>
            </div>

            <div className="col-sm-2">
              <form id="leadFilterForm" method="post" accept-charset="utf-8" />
              <input
                type="date"
                className="form-control datepick"
                placeholder="Date"
                autocomplete="off"
                name="date"
                id="date"
              />
            </div>
            <div className="col-sm-2">
              <input
                type="date"
                className="form-control"
                placeholder="Keyword"
                name="keyword"
                id="keyword"
              />
            </div>
            <div className="col-sm-4">
              <button
                type="button"
                className="btn btn-success"
                id="bbpsSearchBtn"
              >
                Search
              </button>
              <a
                href="https://www.payol.in/portal/report/bbps"
                className="btn btn-secondary"
              >
                View All
              </a>
            </div>
          </div>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table
              className="table table-bordered table-striped"
              id="bbpsDataTable"
              width="100%"
              cellspacing="0"
            >
              <thead>
                <tr>
                  <th>#</th>
                  <th>RechargeID</th>
                  <th>MemberID</th>
                  <th>Operator</th>
                  <th>K/Consumer Number</th>
                  <th>Bill Unit/Customer</th>
                  <th>Amount</th>
                  <th>OB</th>
                  <th>CB</th>
                  <th>TxnID</th>
                  <th>Date Time</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tfoot>
                <tr>
                  <th>#</th>
                  <th>RechargeID</th>
                  <th>MemberID</th>
                  <th>Operator</th>
                  <th>K/Consumer Number</th>
                  <th>Bill Unit/Customer</th>
                  <th>Amount</th>
                  <th>OB</th>
                  <th>CB</th>
                  <th>TxnID</th>
                  <th>Date Time</th>
                  <th>Status</th>
                </tr>
              </tfoot>
              <tbody></tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default Bbpshistory;
